import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import { PipesModules } from '../pipes/pipes.modules';
import { DirectivesModules } from '../directives/directives.module';
import { YouTubePlayerModule } from "@angular/youtube-player";

import { WordDispComponent } from './word-disp/word-disp.component';
import { WordHomonymDispComponent } from './word-disp/word-homonym-disp.component';
import { WordDetailComponent } from './word-detail/word-detail.component';
import { WordDetailDialectComponent } from "./word-detail/word-detail-dialect.component";
import { ProverbItemComponent } from './proverb-item/proverb-item.component';
import { DialectDispComponent } from './word-disp/dialect-disp.component';
import { DialectDetailComponent } from './dialect-detail/dialect-detail.component';
import { DialectDetailStandardComponent } from "./dialect-detail/dialect-detail-standard.component";
import { DialectMapComponent } from './dialect-map/dialect-map.component';
import { LeftMenuComponent } from './left-menu/left-menu.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { BookmarkPopupComponent } from './bookmark-popup/bookmark-popup.component';
import { LinkContentComponent } from "./link-content/link-content.component";
import { LinkExampleComponent } from "./link-example/link-example.component";
import { LinkedExamplePopupComponent } from "./linked-example-popup/linked-example-popup.component";
import { LinkPopupComponent } from './link-popup/link-popup.component';
import { LinkPopupItemDialectComponent } from './link-popup/link-popup-item-dialect.component';
import { LinkPopupItemWordComponent } from './link-popup/link-popup-item-word.component';
import { CommonPopupsComponent } from './common-popups/common-popups.component';
import { MsgPopupComponent } from './msg-popup/msg-popup.component';
import { VideoBoxComponent } from './video-box/video-box.component';
import { VideoItemComponent } from './video-box/video-item.component';
import { VideoBoxMainComponent } from './video-box/video-box-main.component';
import { WordPlayBtnComponent } from './word-play-btn/word-play-btn.component';
import { WordExPlayBtnComponent } from './word-play-btn/word-ex-play-btn.component';
import { WordHelpComponent } from "./word-help/word-help.component";
import { WordRecordBtnComponent } from './word-record-btn/word-record-btn.component';
import { WordHomonymPlayBtnComponent } from './word-play-btn/word-homonym-play-btn.component';
import { HomonymWordPlayBtnComponent } from './word-play-btn/homonym-word-play-btn.component';
import { HomonymAllPlayBtnComponent } from './word-play-btn/homonym-all-play-btn.component';
import { PopupWordPlayBtnComponent } from "./word-play-btn/popup-word-play-btn.component";
import { OptionItemComponent } from './option-item/option-item.component';
import { WordPitchPopupComponent } from './word-pitch-popup/word-pitch-popup.component';
import { WordExamplePopupComponent } from "./word-example-popup/word-example-popup.component";
import { WavGraphComponent } from './word-pitch-popup/wav-graph.component';
import { NaverLoginPopupComponent } from './common-popups/naver-login-popup.component';
import { WordItemComponent } from './word-item/word-item.component';
import { WordDispListItemComponent } from './word-disp-list-item/word-disp-list-item.component';
import { YoutubePlayerComponent } from './youtube-player/youtube-player.component';
import { OtherRegionDialectComponent } from './dialect-detail/other-region-dialect.component';
import { DialectItemComponent } from './dialect-item/dialect-item.component';
import { NotiPopupComponent } from './noti-popup/noti-popup.component';
import { HunPopupComponent } from './hun-popup/hun-popup.component';
import { HunContentComponent } from './hun-content/hun-content.component';
import { HunHanjaItemComponent } from './hun-popup/hun-hanja-item.component';
import { WordExampleBtnComponent } from './word-example-btn/word-example-btn.component';
import { ExampleDispComponent } from './example-disp/example-disp.component';
import { ExamplePlayBtnComponent } from './example-play-btn/example-play-btn.component';
import { WordHanjaPopupComponent } from './word-hanja-popup/word-hanja-popup.component';
import { HanjaCharComponent } from './word-disp/hanja-char.component';
import { HanjaContentComponent } from "./hanja-content/hanja-content.component";
import { HanjaWordPopupComponent } from './hanja-word-popup/hanja-word-popup.component';
import { PitchHelpPopupComponent } from './pitch-help-popup/pitch-help-popup.component';
import { ExampleHelpComponent } from './example-help/example-help.component';
import { Saseung3ItemComponent } from '../../saseung3/saseung3-item/saseung3-item.component';

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModules,
    DirectivesModules,
    YouTubePlayerModule,
  ],
  declarations: [
    WordDispComponent,
    WordHomonymDispComponent,
    WordDetailComponent,
    WordDetailDialectComponent,
    ProverbItemComponent,
    DialectDispComponent,
    DialectDetailComponent,
    DialectDetailStandardComponent,
    DialectMapComponent,
    LeftMenuComponent,
    FooterComponent,
    HeaderComponent,
    BookmarkPopupComponent,
    LinkContentComponent,
    LinkExampleComponent,
    LinkedExamplePopupComponent,
    LinkPopupComponent,
    LinkPopupItemWordComponent,
    LinkPopupItemDialectComponent,
    CommonPopupsComponent,
    MsgPopupComponent,
    VideoBoxComponent,
    VideoItemComponent,
    VideoBoxMainComponent,
    WordPlayBtnComponent,
    WordExPlayBtnComponent,
    WordHelpComponent,
    WordRecordBtnComponent,
    WordHomonymPlayBtnComponent,
    HomonymWordPlayBtnComponent,
    HomonymAllPlayBtnComponent,
    PopupWordPlayBtnComponent,
    OptionItemComponent,
    WordPitchPopupComponent,
    WordExamplePopupComponent,
    WavGraphComponent,
    NaverLoginPopupComponent,
    WordItemComponent,
    WordDispListItemComponent,
    YoutubePlayerComponent,
    OtherRegionDialectComponent,
    DialectItemComponent,
    NotiPopupComponent,
    HunPopupComponent,
    HunContentComponent,
    HunHanjaItemComponent,
    WordExampleBtnComponent,
    ExampleDispComponent,
    ExamplePlayBtnComponent,
    WordHanjaPopupComponent,
    HanjaCharComponent,
    HanjaContentComponent,
    HanjaWordPopupComponent,
    PitchHelpPopupComponent,
    ExampleHelpComponent,
    Saseung3ItemComponent,
  ],
  exports: [
    WordDispComponent,
    WordHomonymDispComponent,
    WordDetailComponent,
    ProverbItemComponent,
    DialectDispComponent,
    DialectDetailComponent,
    DialectMapComponent,
    LeftMenuComponent,
    FooterComponent,
    HeaderComponent,
    LinkContentComponent,
    LinkExampleComponent,
    LinkPopupComponent,
    LinkPopupItemWordComponent,
    LinkPopupItemDialectComponent,
    CommonPopupsComponent,
    VideoBoxComponent,
    VideoItemComponent,
    VideoBoxMainComponent,
    WordPlayBtnComponent,
    WordExPlayBtnComponent,
    WordHelpComponent,
    WordRecordBtnComponent,
    WordHomonymPlayBtnComponent,
    HomonymWordPlayBtnComponent,
    HomonymAllPlayBtnComponent,
    PopupWordPlayBtnComponent,
    OptionItemComponent,
    WordPitchPopupComponent,
    WavGraphComponent,
    WordItemComponent,
    WordDispListItemComponent,
    DialectItemComponent,
    HunContentComponent,
    WordExampleBtnComponent,
    ExampleDispComponent,
    ExamplePlayBtnComponent,
    HanjaContentComponent,
    HanjaWordPopupComponent,
    PitchHelpPopupComponent,
    ExampleHelpComponent,
    Saseung3ItemComponent,
  ],
})
export class ComponentsModules {}
